module.exports = __webpack_public_path__ + "static/media/it.305d160d.svg";